import {EditContacts} from '../widgets';
import {connect} from 'react-redux';
import actions from './community.actions';
import {uiActions} from '../chrome';

const ConnectedEditContacts = connect(
	({community}) => ({
		contacts: community && community.editingContacts
	}),
	dispatch => ({
		onChange: (type, detail) => dispatch(actions.communityChangeEditContacts({type, detail})),
		onSave: () => {
			dispatch(actions.persistContacts());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(EditContacts);

export default ConnectedEditContacts;



// WEBPACK FOOTER //
// ./src/community/CommunityEditContacts.js